import { render, staticRenderFns } from "./StudentAnalytics.vue?vue&type=template&id=d6d1425e&scoped=true&"
import script from "./StudentAnalytics.vue?vue&type=script&lang=js&"
export * from "./StudentAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./StudentAnalytics.vue?vue&type=style&index=0&id=d6d1425e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d1425e",
  null
  
)

export default component.exports